__turbopack_context__.v({
  "bba": "LoginTemplate-module__9tm5Yq__bba",
  "buttonRow": "LoginTemplate-module__9tm5Yq__buttonRow",
  "debugInfo": "LoginTemplate-module__9tm5Yq__debugInfo",
  "errorMessageArea": "LoginTemplate-module__9tm5Yq__errorMessageArea",
  "footerExtras": "LoginTemplate-module__9tm5Yq__footerExtras",
  "loginLayout": "LoginTemplate-module__9tm5Yq__loginLayout",
  "logo": "LoginTemplate-module__9tm5Yq__logo",
  "panel": "LoginTemplate-module__9tm5Yq__panel",
  "panelFooter": "LoginTemplate-module__9tm5Yq__panelFooter",
});
